// Sprint 5-b PWA · 語音行事曆 + 會議室 API（對接 backend #268）· axios 自動帶 auth/txn header
import axios from '../../../../api/axios';

const B = '/api/ee';

export interface ParsedEventFields {
  summary: string | null;
  dtstart: string | null;
  dtend: string | null;
  location: string | null;
  description: string | null;
  rrule: string | null;
  event_type: 'task' | 'meeting' | 'reminder' | 'personal';
  attendee_user_ids: number[];
}
export interface VoiceParseResult {
  event_fields: ParsedEventFields;
  missing_fields: string[];
  ambiguous_attendees: { name: string; matches: { user_id: number; username: string }[] }[];
  unmatched_attendees: string[];
  confidence: number;
  cost: { ntd: number; tokens: number };
}

export interface ActionItem {
  id: string; content: string; assignee_user_id: number | null;
  assignee_name?: string | null; due: string | null; status: string;
}
export interface Minutes {
  id: number; event_id: number; status: 'recording' | 'processing' | 'done';
  summary: string | null; decisions: { content: string; assignee_user_id: number | null }[];
  action_items: ActionItem[]; attendees_recognized: string[];
  attendee_user_ids: number[]; reader_user_ids: number[]; full_transcript: string;
  total_input_tokens: number; total_output_tokens: number; total_cost_ntd: number;
  started_at: string | null; ended_at: string | null;
}

export const voiceParse = (transcript: string, user_tz = 'Asia/Taipei'): Promise<VoiceParseResult> =>
  axios.post(`${B}/calendar/voice-parse`, { transcript, user_tz }).then((r) => r.data);

export const startRecording = (eventId: number): Promise<Minutes> =>
  axios.post(`${B}/meetings/${eventId}/start-recording`).then((r) => r.data);

export const uploadChunk = (eventId: number, chunkIndex: number, transcript: string,
                            durationMs: number): Promise<{ minutes_id: number; chunk_count: number }> =>
  axios.post(`${B}/meetings/${eventId}/voice-chunk`,
    { chunk_index: chunkIndex, transcript, duration_ms: durationMs }).then((r) => r.data);

export const stopRecording = (eventId: number): Promise<Minutes> =>
  axios.post(`${B}/meetings/${eventId}/stop-recording`).then((r) => r.data);

export const getMinutes = (eventId: number): Promise<Minutes> =>
  axios.get(`${B}/meetings/${eventId}/minutes`).then((r) => r.data);

export const updateMinutes = (eventId: number, body: Partial<Minutes>): Promise<Minutes> =>
  axios.put(`${B}/meetings/${eventId}/minutes`, body).then((r) => r.data);

export const estimateCost = (minutes: number): Promise<{ estimated_ntd: number; model: string }> =>
  axios.post(`${B}/meetings/estimate-cost`, { estimated_duration_min: minutes }).then((r) => r.data);
